import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b3bfefe"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-test"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "textbox__asterisk",
  "aria-hidden": "true"
}, "*", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "sr-only" }, "(required)", -1))
const _hoisted_4 = ["disabled", "maxlength", "minlength", "max", "min", "placeholder", "readonly", "required", "type", "value"]
const _hoisted_5 = ["disabled", "maxlength", "minlength", "max", "min", "placeholder", "readonly", "required", "type", "value"]
const _hoisted_6 = ["disabled", "maxlength", "minlength", "placeholder", "readonly", "required", "value"]
const _hoisted_7 = {
  key: 3,
  class: "textbox__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tag = _resolveComponent("tag")!

  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["textbox", _ctx.required ? 'textbox--required' : null]),
    "data-test": `label- ${_ctx.label}`
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(_ctx.hideLabel ? 'sr-only' : null)
    }, [
      _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
      (_ctx.required)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_2,
            _hoisted_3
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    ((_ctx.icon || _ctx.tag) && !_ctx.multiline)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(["textbox__entry textbox__icon", _ctx.status ? `textbox--${_ctx.status}` : ''])
        }, [
          _createElementVNode("i", {
            class: _normalizeClass('icon-' + _ctx.icon)
          }, null, 2),
          _withDirectives(_createElementVNode("input", {
            class: "textbox__input",
            disabled: _ctx.disabled,
            maxlength: _ctx.maxlength,
            minlength: _ctx.minlength,
            max: _ctx.max,
            min: _ctx.min,
            placeholder: _ctx.placeholder,
            readonly: _ctx.readonly,
            required: _ctx.required,
            type: _ctx.type,
            value: _ctx.localInputValue,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localInputValue) = $event)),
            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
          }, null, 40, _hoisted_4), [
            [_vModelDynamic, _ctx.localInputValue]
          ]),
          (_ctx.tag)
            ? (_openBlock(), _createBlock(_component_tag, {
                key: 0,
                class: "mr-2",
                color: "secondary",
                pill: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.tag), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.multiline && !_ctx.icon && !_ctx.tag)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          class: _normalizeClass(["textbox__entry", _ctx.status ? `textbox--${_ctx.status}` : '']),
          id: "localInputValue",
          disabled: _ctx.disabled,
          maxlength: _ctx.maxlength,
          minlength: _ctx.minlength,
          max: _ctx.max,
          min: _ctx.min,
          placeholder: _ctx.placeholder,
          readonly: _ctx.readonly,
          required: _ctx.required,
          type: _ctx.type,
          value: _ctx.localInputValue,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localInputValue) = $event)),
          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
          onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
          onFocus: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args)))
        }, null, 42, _hoisted_5)), [
          [_vModelDynamic, _ctx.localInputValue]
        ])
      : _createCommentVNode("", true),
    (_ctx.multiline && !_ctx.icon && !_ctx.tag)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 2,
          class: _normalizeClass(["textbox__entry textbox__textarea", _ctx.status ? `textbox--${_ctx.status}` : '']),
          disabled: _ctx.disabled,
          maxlength: _ctx.maxlength,
          minlength: _ctx.minlength,
          placeholder: _ctx.placeholder,
          readonly: _ctx.readonly,
          required: _ctx.required,
          value: _ctx.localInputMultiLineValue,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localInputMultiLineValue) = $event)),
          onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
          onInput: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
        }, null, 42, _hoisted_6)), [
          [_vModelText, _ctx.localInputMultiLineValue]
        ])
      : _createCommentVNode("", true),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.message), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}